(ns app.strive-forms.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass defkeyframes]]
   [app.views :refer [responsive-screen-width]]
   [garden.stylesheet :refer [at-media]]
   [app.strive-forms.defaults :refer [default-values]]))

(defclass form-container-theme
  []
  {:position "relative"})

(defclass form-background [{:keys [opacity url]}]
  {:position "absolute"
   :display "block"
   :content "' '"
   :bottom "0"
   :left "0"
   :width "100%"
   :height "100%"
   :opacity (when-not (nil? opacity) (/ opacity 100))
  ;;  :object-fit "cover"
   :z-index "-1"
   :background-image (str "url(" url ")")})

(defclass questions-icons-area-style []
  {:width (responsive-screen-width "736px")
   :display "flex"
   :justify-content "space-between"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "100%"})])

(defclass empty-blank-space-style [{:keys [width]}]
  {:background "transparent"
   :width width
   :border "none"})

(defclass num-of-steps-style [{:keys [color]}]
  {:margin "0px"
   :font-size "16px"
   :color color}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:font-size "12px"})])

(defclass question-gap-style [{:keys [primary-gap secondary-gap]}]
  {:height primary-gap}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:height secondary-gap})])

(defclass form-content-style []
  {:position "relative"
   :height "65%"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:height "65%"})]
  [:.react-swipeable-view-container
   {:transition "all 1s ease 0s !important"}])

(defclass question-card-container-style []
  {:margin-left "5%"
   :margin-right "5%"})

(defclass questions-area-style []
  {:align-self "center"
   :width "736px"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "100%"})])



(defclass question-card-style []
  {:height "89%"})

(defclass question-title-area-style
  []
  {}
  [(at-media {:max-width "1340px"}
             {:font-size "20px"
              :width "100%"})])

(defclass question-description-field-style [{:keys [theme-data]}]
  {:display "flex"
   :white-space "pre-wrap"
   :flex-direction "column"
   :align-items "center"
   :text-align "center"
   :margin "0px"
   :font-size "20px"
   :width "600px"
   :color theme-data}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:font-size "15px !important"
              ;; :max-height "40px"
              :width "100%"
              :max-width "320px"})]
  [:p {:margin "0px"}])

(defclass warning-notification [{:keys [width color]}]
  {:width width
   :align-self "center"
   :margin-left "5px"
   :margin-top "1px"
   :height "21.6px"
   :font-size "12px"
   :color color}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "100%"
              :margin-left "5px"})])

(defclass action-button-area-style []
  {:width "180px"
   :height "44px"
   :align-self "center"})

(defclass action-button-style [{:keys [theme-data preview]}]
  {:border-radius "5px"
   :font-size "16px"
   :font-weight "600"
   :border-color "transparent"
   :padding "9px 24px"
   :align-self "center"
   :width "180px"
   :height "50px"
   :transform {:translateX "-50%" :translateY "-50%"}
   :box-shadow (str "0px 10px 23px 0px " (if preview "#EC294F" (:buttons_color theme-data)) "30")
   :color (:buttons_text_color theme-data)
   :background (if preview "#EC294F"(:buttons_color theme-data))}
  [:&:disabled
   {:color :theme/*disabled*
    :background-color  :theme/*grey350*
    :border-color "transparent"
    :outline "none"
    :box-shadow "none"}]
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "100%"})])


(defclass form-page-footer-style []
  {:box-sizing "border-box"
   :display "flex"
   :flex-direction "row"
   :align-items "center"
   :padding "8px 16px"
   :gap "4px"
   :position "absolute"
   :width "142px"
   :height "33px"
   :left "15px"
   :bottom "15px"
   :border "1px solid #DEDCE0"
   :box-shadow "0px 2px 4px -2px rgba(0, 0, 0, 0.06), 0px 2px 4px rgba(0, 0, 0, 0.04)"
   :border-radius "4px"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "125px"
              :padding "8px 10px"
              :height "33px"})])

(defclass footer-style-left-side []
  {:width "76px"
   :height "8px"
   :font-family "'Lato'"
   :font-style "normal"
   :font-weight "400"
   :font-size "14px"
   :line-height "17px"
   :display "flex"
   :align-items "center"
   :color "#8D8793"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "59px"
              :font-size "12px"
              :height "8px"})])

(defclass footer-style-right-side []
  {:width "40px"
   :height "8px"
   :font-family "'Pacifico', cursive"
   :font-style "normal"
   :font-weight "400"
   :font-size "15px"
   :line-height "48%"
   :color "#66606B"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "23px"
              :height "8px"})])

(defclass responsive-input-field-style [{:keys [input-font-color title-field-color border-color]}]
  {:border-radius "8px"
   :box-sizing "content-box"
   :padding-bottom "1px !important"
   :width "350px"
   :outline "none"
   :display "flex "
   :justify-content "flex-start"
   :flex-direction "column"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width "100% !important"})]
  [:.MuiBox-root {:width "100%"
                  :display "contents"
                  :justify-content "center"}]
  [:.MuiOutlinedInput-notchedOutline {:border-color border-color
                                      :border-width "1px !important"}]
  [:.MuiOutlinedInput-root {:border-color border-color}]
  [:.MuiFilledInput-root {:background-color "transparent"
                          :width "313px"}
   [(at-media {:max-width (:width-for-mobile-view default-values)}
              {:width "80% !important"})]]
  [:.MuiFilledInput-root:hover {:background-color "transparent"}]
  [:.MuiInputBase-input {:height "18px"
                         :font-size "18px"
                         :font-weight "300"
                         :color (str input-font-color)}]
  [:.Mui-focused {:color "black"}]
  [:.MuiFormLabel-root {:color (str title-field-color)
                        :font-weight "200"}]
  [:.MuiTextField-root {:border-radius "6px"}]
  [:.MuiFilledInput-underline {:disableUnderline true}]
  [:input::-webkit-outer-spin-button {:-webkit-appearance "none"
                                      :margin 0}]
  [:input::-webkit-inner-spin-button {:-webkit-appearance "none"
                                      :margin 0}])

(defclass email-icon-style []
  {:align-self "center"
   :margin-left "8px"
   :justify-self "center"})

(defclass responsive-input-field-border-class [{:keys [border-color border-size margin width]}]
  {:border border-size
   :border-color border-color
   :box-shadow "0px 0px 0px 2px #eee"
   :margin margin
   :border-bottom-left-radius "4px"
   :border-top-left-radius "4px"
   :border-bottom-right-radius "4px"
   :border-top-right-radius "4px"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:width width})])

(defclass num-input-style []
  {}
  [:-webkit-outer-spin-button {:-webkit-appearance "none"
                               :margin 0}]
  [:-webkit-inner-spin-button {:-webkit-appearance "none"
                               :margin 0}])

(defclass thank-you-background-image []
  {})




(defclass page-sticky-title-style [font-family font-color font-size text-align title-component-width question-title-height background-color]
  {:font-size font-size
   :font-weight "500"
   :font-family font-family
   :text-align text-align
   :max-height question-title-height
   :width title-component-width
   :overflow "auto"
   :background-color background-color
   :color font-color
   :transform {:translateY "-100%"}
   :animation "slide-down 1s forwards"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:max-height "200px"
              :width "100%"
              :font-size "32px"})]
  [(at-media {:max-height "600px"}
             {:max-height "130px"})]
  [:p {:margin "0px"}])

(defclass page-title-style [font-family font-color font-size text-align title-component-width question-title-height background-color]
  {:font-size font-size
   :font-weight "500"
   :font-family font-family
   :text-align text-align
   :max-height question-title-height
   :width title-component-width
   :overflow "auto"
   :background-color background-color
   :color font-color}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:max-height "200px"
              :width "100%"
              :font-size "32px"})]
  [(at-media {:max-height "600px"}
             {:max-height "130px"})]
  [:p {:margin "0px"}])

(defclass page-subtitle-style [{:keys [theme-data]}]
  {:display "flex"
   :white-space "pre-wrap"
   :flex-direction "column"
   :align-items "center"
   :text-align "center"
   :margin "0px"
   :font-size "20px"
   :color theme-data}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:font-size "15px !important"
              :max-height "40px"
              :width "100%"})]
  [:p {:margin "0px"}])

(defclass question-field-style [font-family font-color font-size text-align title-component-width question-title-height is-required]
  {:font-size font-size
   :font-weight "500"
   :font-family font-family
   :text-align text-align
   :max-height question-title-height
   :width title-component-width
   :overflow "auto"
   :color font-color}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:max-height "200px"
              ;; :max-width "240px"
              :width "95%"
              :font-size "22px"})]
  [(at-media {:max-height "600px"}
             {:max-height "130px"})]
  [:p {:margin "0px"}
   (when is-required
     [:&:last-child {}
      [:&:after
       {:content "'*'"
        :color "#EC294F"
        :margin-left "5px"}]])])

(defclass text-field-style [{:keys [color theme-data width]}]
  {:width width
   :border-radius "8px"
   :padding "13px 16px"
   :font-size "20px"
   :outline "none"
   :max-width width
   :min-width width
   :color color
   :background (str (:answers_background_color theme-data) "45")
   :border (str "1px solid" (if (nil? (:answers_border_color theme-data)) "#9c9ea8" (:answers_border_color theme-data)))}
  [:&::placeholder {:color (str color "45")}])

(defclass selection-list-style []
  {:height "100%"
   :margin "0 auto"
   :font-size "20px"
   :align-items "center"
   :align-self "center"
   :font-weight "400"
   :padding-top "0px"
   :padding-bottom "0px"})

(defclass list-group-style []
  {:font-weight "400"
   :font-size "20px"
   :align-self "center"})

(defclass list-group-item-style [{:keys [background-color border-color answer-color border-size margin text-align]}]
  {:min-height "51px"
   :height "auto"
   :align-items "center"
   :border-radius "5px"
   :text-align text-align
   :font-size "18px"
   :width "410px"
   :margin      margin
   :background background-color
   :color answer-color
   :border (str border-size border-color)
   :white-space "break-spaces"}
  [:span {:max-width "330px"
          :word-break "break-word"
          :font-size "18px !important"
          :color answer-color}]
  [:.Mui-checked {:color border-color}])

(defclass list-group-item-text-style [{:keys [answer-color]}]
  {:font-size "18px !important"
   :color (str answer-color " !important")
   :margin-left "7px"
   :margin-right "7px"})

(defclass numbers-scale-component-style [{:keys [width flex-wrap]}]
  {:width width
   :display "flex"
   :flex-wrap flex-wrap
   :max-height "195px"
   :justify-content "center"
   :gap "8px"}
  [(at-media {:max-width (:width-for-mobile-view default-values)}
             {:height "auto"
              })])

(defclass num-scale-button-wrapper-style [{:keys [width]}]
  {:width width})



(defclass number-scale-labels-component-style [{:keys [width color align-self]}]
  {:width width
   :margin-top "0.2em"
   :display "flex"
   :font-size "16px"
   :color color
   :font-weight "600"
   :justify-content "space-between"
   :align-self align-self})

(defclass number-scale-label-style [{:keys [font-size]}]
  {:margin-top "auto"
   :font-size font-size})

(defclass number-scale-button [{:keys [background-color border-color answer-color buttons-color buttons-text-color]}]
  {:width "100%"
   :border-radius "8px"
   :height "55px"
   :font-size "20px"
   :background background-color
   :color answer-color
   :border (str "1px solid " border-color)
   :font-weight "600"}
  [:&:hover {:border (str "1px solid " border-color)}]
  [:&:active
   {:box-shadow (str "6px 4px 14px 4px " buttons-color "90")
    :color buttons-text-color
    :border "none"
    :background buttons-color
    :outline "none"}])

(defclass num-scale-underline-style [{:keys [background-color]}]
  {:border-bottom "2px solid"
   :height "2px"
   :border-color background-color
   :margin-right "-8px"})



(defclass selected-number-scale-button [{:keys [buttons-color buttons-text-color]}]
  {:width "100%"
   :border-radius "8px"
   :height "55px"
   :font-size "20px"
   :font-weight "600"
   :box-shadow (str "6px 4px 14px 4px " buttons-color "90")
   :color buttons-text-color
   :border "none"
   :background buttons-color
   :outline "none"})


(defclass boolean-field-component-style
  [{:keys [border accent-color background border-size]}]
  {:margin "2px"
   :height "47px"
   :width "300px"
   :font-size "20px"
   :accent-color accent-color
   :display "flex"
   :align-items "center"
   :border-radius "4px"
   :padding "2px 10px 2px 10px"
   :background (str background "60")
   :border-size border-size
   :border border
   :brightness "1.75"
   :cursor "pointer"}
  [:&:hover {:background (str background "80")}])

(defclass letter-checkbox-style
  [{:keys [background-color text-color border-color]}]
  {:display "flex"
   :border (str "1px solid " border-color)
   :width "30px"
   :height "30px"
   :color text-color
   :background background-color
   :margin-right "10px"
   :text-align "center"
   :align-items "center"
   :justify-content "center"
   :border-radius "3px"})

(defclass letter-checkbox-label-style []
  {:cursor "pointer"
   :padding "5px"})

(defclass letter-checkbox-input-style []
  {:display "none"})

(defclass radio-dot-button-style
  []
  {:justify-content "center"
   :align-items "center"
   :width "100%"
   :height "24px"
   :margin "0px"
   :cursor "pointer"})



(defclass phone-number-input-style
  []
  {:width (responsive-screen-width "760px")
   :display "flex"
   :justify-content "center"
   :padding-left "20px"
   :font-size "2rem"}
  [:.MuiInputBase-input {:font-size "20px"
                         :padding-left "14px"} [:&:hover {:border-color "red"}]]

  [:.MuiIconButton-root {:padding-left "14px"}])


(defclass phone-number-input-secondary-style
  []
  {:justify-content "center"
   :align-items "center"
   :width (responsive-screen-width "760px")
   :font-size "2rem"})


(defclass phone-input-warning-notification []
  {:height "18.6px"
   :justify-content "center"
   :align-items "center"
   :align-self "center"
   :font-size "16px"
   :color :theme/*redActive*})

(defclass languages-dropdown-style []
  {:color "red"})

(defclass progress-label-style [{:keys [description-color]}]
  {:display "flex"
   :justify-content "flex-end"
   :font-size "14px"
   :font-weight "500"
   :color description-color})

(defclass progress-bar-close-button-style []
  {:align-self "end"})

(defclass linear-progress-style [{:keys [primary-color background-color]}]
  {:border-radius "20px"}
  [:.MuiLinearProgress-colorPrimary {:background-color background-color}]
  [:.MuiLinearProgress-barColorPrimary {:background-color primary-color}])

(defclass preview-question-title [color]
  {:color color
   :line-height "12px"
   :font-size "12px"})

(defkeyframes load []
  ["0%" {:background-position "right"}]
  ["50%" {:background-position "left"}]
  ["100%" {:background-position "right"}])

(defclass first-question-title-skeleton [border-color]
  {:margin-bottom "6px"
   :border-radius "50px"
   :width "20%"
   :height "5px"
   :background  (str "linear-gradient(to right, #f1f0f0," border-color ", #f1f0f0)")
   :background-size "200%"
   :background-position "left"
   :animation [[(load) "10s" 'ease-in-out "0s infinite normal"]]})

(defclass question-title-skeleton [border-color]
  {:border-top "5px solid"
   :margin-bottom "6px"
   :border-color border-color
   :border-radius "50px"
   :width "20%"})

(defclass first-question-response-skeleton [border-color]
  {:margin-bottom "6px"
   :border-radius "50px"
   :width "80%"
   :height "8px"
   :background  (str "linear-gradient(to right, #f1f0f0, " border-color ", #f1f0f0)")
   :background-size "200%"
   :background-position "left"
   :animation [[(load) "10s" 'ease-in-out "0s infinite normal"]]})


(defclass question-response-skeleton [border-color]
  {:border-top "8px solid"
   :border-radius "50px"
   :border-color border-color
   :width "80%"})

(defclass preview-panel-answer-span []
  {:white-space "break-spaces"})


(defclass response-drawer-style []
  {}
  [:.MuiPaper-root {:border-top-left-radius "20px"
                    :border-top-right-radius "20px"}])

(defclass page-title-link []
  {:width "100%"}
  [:.rc-hyperlink-container {:width "100%"}])
